module.exports = __webpack_public_path__ + "img/guali(2).a597e92f.jpg";